// Emitted in place of a Linear result when the org has no usable Linear
// integration for this project. `auth_broken` is the one reason that means the
// workspace was connected and then stopped working: the credential was revoked
// or the re-mint failed, and nothing syncs until an admin re-saves it.
export interface LinearSetupRequiredPayload {
  type: "linear_setup_required";
  reason: "workspace_not_configured" | "not_exposed" | "auth_broken";
}

const REASONS: ReadonlySet<LinearSetupRequiredPayload["reason"]> = new Set([
  "workspace_not_configured",
  "not_exposed",
  "auth_broken",
]);

const isReason = (v: unknown): v is LinearSetupRequiredPayload["reason"] =>
  typeof v === "string" && REASONS.has(v as LinearSetupRequiredPayload["reason"]);

// Tolerates unknown reasons so a newer backend still renders the card.
export const parseLinearSetupRequiredPayload = (v: unknown): LinearSetupRequiredPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_setup_required") return null;
  return {
    type: "linear_setup_required",
    reason: isReason(r.reason) ? r.reason : "workspace_not_configured",
  };
};
